import { KoAPI } from "packages";
import { configs } from "configuration";

const version = configs().API_VERSION;

export const subscriptionAPI = {
  createPlan(data) {
    return KoAPI.post(`/api/${version}/subscription/plan`, {data});
  },

  getPlanById(planId) {
    return KoAPI.get(`/api/${version}/subscription/plan/${planId}`);
  },

  createSubscription(planId, data) {
    return KoAPI.post(
      `/api/${version}/subscription/create`,
      {data}
    );
  },

  manageSubscription(subscriptionId, data) {
    return KoAPI.post(
      `/api/${version}/subscription/manage/${subscriptionId}`,
      {data}
    );
  },

  getSubscriptionById(subscriptionId) {
    return KoAPI.get(
      `/api/${version}/subscription/${subscriptionId}`
    );
  },
  getPlans() {
    return KoAPI.get(`/api/${version}/subscription/plan`);
  }
};
